<shared-square-image [src]="src" [loading]="loading" [alt]="title" [imgBg]="false" imgWidth="95%" [radius]="radius"
    class="thumb-for-order-type">
</shared-square-image>